// ./src/index.js
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css'; // Ensure you import the Tailwind CSS file here
import App from './App';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
reportWebVitals();